import MyLocationForm from './MyLocationForm.container';

export default MyLocationForm;
